import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { AppLayout } from '@/components/layout/AppLayout';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import DevicesList from './pages/DevicesList';
import DeviceDetail from './pages/DeviceDetail';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import Endpoints from './pages/Endpoints';
import EndpointDetail from './pages/EndpointDetail';
import Alerts from './pages/Alerts';
import Inventory from './pages/Inventory';
import MassOps from './pages/MassOps';
import MassOpDetail from './pages/MassOpDetail';
import Onts from './pages/Onts';
import OntDetail from './pages/OntDetail';
import Olts from './pages/Olts';
import CoaxMasters from './pages/CoaxMasters';
import CoaxEndpoints from './pages/CoaxEndpoints';
import CoaxEndpointDetail from './pages/CoaxEndpointDetail';
import CoaxMasterDetail from './pages/CoaxMasterDetail';
import DataProfiles from './pages/DataProfiles';
import VoiceProfiles from './pages/VoiceProfiles';
import Settings from './pages/Settings';
import { VersionWatcher } from '@/components/ui/VersionWatcher';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, fetchMe, user } = useAuth();
  useEffect(() => { if (isAuthenticated && !user) fetchMe(); }, [isAuthenticated, user, fetchMe]);
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
}

const Placeholder = ({ title }: { title: string }) => (
  <div className="p-8 text-text-faint">
    <h1 className="text-xl font-semibold text-text mb-2">{title}</h1>
    <p>Page à venir.</p>
  </div>
);

export default function App() {
  return (
    <>
      <VersionWatcher />
    <Routes>
      <Route path="/"      element={<Landing />} />
      <Route path="/login" element={<Login />} />

      <Route path="/app" element={<RequireAuth><AppLayout /></RequireAuth>}>
        <Route index                    element={<Dashboard />} />
        <Route path="devices"           element={<DevicesList />} />
        <Route path="devices/:id"       element={<DeviceDetail />} />
        <Route path="customers"         element={<Customers />} />
        <Route path="customers/:id"     element={<CustomerDetail />} />
        <Route path="endpoints"         element={<Endpoints />} />
        <Route path="endpoints/:id"     element={<EndpointDetail />} />
        <Route path="inventory"         element={<Inventory />} />
        <Route path="mass-ops"          element={<MassOps />} />
        <Route path="mass-ops/:id"      element={<MassOpDetail />} />
        <Route path="onts"              element={<Onts />} />
        <Route path="onts/:id"          element={<OntDetail />} />
        <Route path="olts"              element={<Olts />} />
        <Route path="coax/masters"       element={<CoaxMasters />} />
        <Route path="coax/masters/:id"   element={<CoaxMasterDetail />} />
        <Route path="coax/endpoints"     element={<CoaxEndpoints />} />
        <Route path="coax/endpoints/:id" element={<CoaxEndpointDetail />} />
        <Route path="profiles"          element={<Navigate to="/app/profiles/data" replace />} />
        <Route path="profiles/data"     element={<DataProfiles />} />
        <Route path="profiles/voice"    element={<VoiceProfiles />} />
        <Route path="plans"             element={<Placeholder title="Service plans" />} />
        <Route path="alerts"            element={<Alerts />} />
        <Route path="settings"          element={<Settings />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
}
